export type AspectRatio = '1:1' | '16:9' | '4:3';
export type ComparisonMode = 'single' | 'side-by-side' | 'stacked';

export interface AnnotationRect {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
}

export interface EditorConfig {
  // Fixed settings for news usage vs configurable for collections
  fixedAspectRatio?: AspectRatio;
  fixedComparisonMode?: ComparisonMode;
  fixedVersionData?: {
    primary?: { version: string; pageId: string };
    secondary?: { version: string; pageId: string };
  };
  // UI controls
  showAspectRatioControls?: boolean;
  showComparisonModeControls?: boolean;
  showVersionSelectors?: boolean;
  showDebugPanel?: boolean;
  hideLeftPanel?: boolean;
  hideHeader?: boolean;
  // Modal vs embedded
  isEmbedded?: boolean;
  forceCompactSize?: boolean;
  // Redirect configuration for Canva returns
  redirect?: {
    originPage: string;
    customReturnPath?: string;
    additionalState?: Record<string, any>;
  };
}

export interface AssetImageEditorRef {
  save: () => Promise<void>;
}

export interface AssetImageEditorProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  asset: Asset;
  onSuccess?: () => void;
  reopenCropEditor?: boolean;
  editorMode?: 'crop' | 'annotation' | 'mask' | null;
  config?: EditorConfig;
}

export interface CropCoordinates {
  x: number;
  y: number;
  scale: number;
  viewportWidth: number;
  viewportHeight: number;
  innerCrop?: {
    left: number;
    top: number;
    width: number;
    height: number;
  };
}

export interface ImageData {
  version: string;
  pageId: string;
  imageUrl?: string;
}

export interface SecondaryImageData {
  version?: string;
  pageId?: string;
  imageUrl?: string;
}

export interface CropRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface DragState {
  x: number;
  y: number;
}

export interface ContainerDimensions {
  width: number;
  height: number;
}

export const ASPECT_RATIOS = {
  '1:1': { ratio: 1, label: '1:1', tooltip: '1200x1200 - LinkedIn Post Size' },
  '16:9': { ratio: 16/9, label: '16:9', tooltip: 'Widescreen' },
  '4:3': { ratio: 4/3, label: '4:3', tooltip: 'Standard' }
} as const;

// Import the Asset type from the existing module
export type { Asset } from '@/utils/collectionsGraphQL';